module.exports = __webpack_public_path__ + "img/rw1.4caf1092.png";